"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ResponsiveImage = require("./ResponsiveImage.style");
var _excluded = ["width", "aspectRatio", "fromS3", "shouldZoom", "containerStyle"];
var ResponsiveImage = function ResponsiveImage(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 16 / 9 : _ref$aspectRatio,
    _ref$fromS = _ref.fromS3,
    fromS3 = _ref$fromS === void 0 ? true : _ref$fromS,
    shouldZoom = _ref.shouldZoom,
    containerStyle = _ref.containerStyle,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.CroppedContainer, {
    width: width,
    aspectRatio: aspectRatio,
    shouldZoom: shouldZoom,
    style: containerStyle
  }, fromS3 ? /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.PositionedS3Image, (0, _extends2["default"])({}, props, {
    shouldZoom: shouldZoom
  })) : /*#__PURE__*/_react["default"].createElement(_ResponsiveImage.PositionedImage, (0, _extends2["default"])({}, props, {
    shouldZoom: shouldZoom
  })));
};
var _default = exports["default"] = ResponsiveImage;